
import React from "react";
import { useEffect, useState } from 'react';

// API fetch
import axios from "axios";
import { baseURL } from '../../../../config/api-config.js';


//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getUserData } from "../../../../store/selectors.js"; //global state : shopping state
import { userDataSlice } from "../../../../store/userDataSlice.js";
import { shoppingStepSlice } from "../../../../store/shoppingStepSlice.js";
import { contratStepSlice } from "../../../../store/contratStepSlice.js";

//MUI Components
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import TextField from '@mui/material/TextField';


// New library (from react-phone-number-input)
import { MuiTelInput, matchIsValidTel } from 'mui-tel-input'

//Translate utils :
import { translator } from "../../../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)


function FormulaireInfosClient() { // infos is an boject sent from StepTwo.jsx, With 3 attibutes : spot, dates, duree




    let userData = useSelector(getUserData); //user infos from global state
    const lang = useSelector(getLang) //global state : language
    const [phone, setPhone] = useState([]);
    const [phoneError, setPhoneError] = useState(false);
    const [telFound, setTelFound] = useState(false);

    const [fields, setFields] = useState(userData); //change and store all fields


    const dispatch = useDispatch();


    const handleChangePhone = (newValue, info) => {
        setPhone([newValue, info]);
        setFields({ ...fields, tel: newValue })

        if (matchIsValidTel(newValue)) {
            setPhoneError(false);
            findClient(info.numberValue);
        }
        else {
            setPhoneError(true);
        }
    }



    const findClient = (phone) => {

        axios.get(`${baseURL}/client/find/${phone}/1`)
            .then((response) => {
                //console.log(response.status);
                if (response.status === 200) {
                    setFields({
                        found: true,
                        id_client: response.data.data[0].id_client,
                        tel: response.data.data[0].tel,
                        email: response.data.data[0].email,
                        prenom: response.data.data[0].prenom,
                        nom: response.data.data[0].nom,
                        adresse: response.data.data[0].adresse,
                        adresse_comp: response.data.data[0].adresse_comp,
                        cp: response.data.data[0].cp,
                        ville: response.data.data[0].ville,
                        pays: response.data.data[0].country,

                    })
                }
                else {
                    setFields({
                        found: false,
                        id_client: 0,
                        tel: phone,
                        email: "",
                        prenom: "",
                        nom: "",
                        adresse: "",
                        adresse_comp: "",
                        cp: "",
                        ville: "",
                        pays: "",

                    })
                }
            })
            .catch((error) => {
                return /* error */;
            });

    }

    function modifChamp(evt, nomChamp) { //modif state for all fields, despite assigned value

        setFields({ ...fields, [nomChamp]: evt.target.value })
    }

    function handleFormSubmit() {

        dispatch(userDataSlice.actions.setUserData({
            found: fields.found,
            id_client: fields.id_client,
            //tel: inputValue.split(" ").join(""),
            tel: /* phone[1].numberValue ??  */fields.tel,
            email: fields.email,
            prenom: fields.prenom,
            nom: fields.nom,
            adresse: fields.adresse,
            adresse_comp: fields.adresse_comp,
            cp: fields.cp,
            ville: fields.ville,
            pays: fields.pays
        }));

        dispatch(shoppingStepSlice.actions.nextShoppingStep()); //go to CGV
        //Manager mode : 
        dispatch(contratStepSlice.actions.nextContratStep()); //go to CGV

    }

    function validateMail() {
        const emailRegex = new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, "gm");
        let isValidEmail = emailRegex.test(fields.email);
        return (!isValidEmail);

    }



    function isFormValid() { // function to manually check form validity
        let mailOK = !validateMail(); //! is necessary because function return !valid
        let allFieldsOK = true;
        let fieldInputs = ["prenom", "nom", "adresse", "cp", "ville", "pays"];
        for (let i = 0; i < fieldInputs.length; i++) { // loop to check every required fields

            if (fields[fieldInputs[i]].length === 0) { allFieldsOK = false; } //if empty => false
        }
        return (phoneError === false && mailOK && allFieldsOK);
    }

    return (
        <div className="formulaire-client">

            <div className="formulaire-client-top">
                <div className="formulaire-client-top-left">


                    <MuiTelInput
                        className="formulaire-client-textfield"
                        label={translator("Téléphone", lang, "formPhone")}
                        error={phoneError}
                        required
                        variant="standard"
                        forceCallingCode
                        focusOnSelectCountry
                        defaultCountry="FR"
                        preferredCountries={['FR', 'BE', 'DE', 'NL', 'ES', 'IT', 'GB', 'US']}
                        disabled={false}
                        value={fields.tel}
                        onChange={handleChangePhone}
                    />


                </div>
                <div className="formulaire-client-top-right">
                    <TextField
                        fullWidth
                        className="formulaire-client-textfield"
                        error={validateMail() && fields.email.length > 0}
                        className="formulaire-client-top-right-input "
                        required
                        label={translator("email", lang, "formEmail")}
                        variant="standard"
                        name="email"
                        value={fields.email}
                        onChange={e => modifChamp(e, "email")}
                    />
                </div>
            </div>
            <div className="formulaire-client-middle">

                <div className="formulaire-client-middle-left">
                    <TextField
                        fullWidth
                        className="formulaire-client-middle-left-input"
                        required
                        label={translator("Prénom", lang, "formPrenom")}
                        variant="standard"
                        name="prenom"
                        value={fields.prenom}
                        onChange={e => modifChamp(e, "prenom")}
                    />

                    <TextField
                        fullWidth
                        className="formulaire-client-middle-left-input"
                        required
                        label={translator("nom", lang, "formNom")}
                        variant="standard"
                        name="nom"
                        value={fields.nom}
                        onChange={e => modifChamp(e, "nom")}
                    />
                </div>

                <div className="formulaire-client-middle-right">
                    <TextField
                        fullWidth
                        className="formulaire-client-middle-right-input"
                        required
                        label={translator("Adresse", lang, "formAddress")}
                        variant="standard"
                        name="adresse"
                        value={fields.adresse}
                        onChange={e => modifChamp(e, "adresse")}
                    />
                    <TextField
                        fullWidth
                        className="formulaire-client-middle-right-input"
                        label={translator("Complément adresse", lang, "formComp")}
                        variant="standard"
                        name="adresse_comp"
                        value={fields.adresse_comp}
                        onChange={e => modifChamp(e, "adresse_comp")}

                    />
                    <TextField
                        fullWidth
                        className="formulaire-client-middle-right-input"
                        required
                        label={translator("CP", lang, "formCp")}
                        variant="standard"
                        name="cp"
                        value={fields.cp}
                        onChange={e => modifChamp(e, "cp")}
                    />
                    <TextField
                        fullWidth
                        className="formulaire-client-middle-right-input"
                        required
                        label={translator("Ville", lang, "formVille")}
                        variant="standard"
                        name="ville"
                        value={fields.ville}
                        onChange={e => modifChamp(e, "ville")}
                    />
                    <TextField
                        fullWidth
                        className="formulaire-client-middle-right-input"
                        required
                        label={translator("Pays", lang, "formPays")}
                        variant="standard"
                        name="pays"
                        value={fields.pays}
                        onChange={e => modifChamp(e, "pays")}
                    />

                </div>
            </div>

            <div className="formulaire-client-bottom">
                {isFormValid() ?
                    null :
                    <Alert
                        className="formulaire-client-bottom-alert"
                        severity="info">{translator("Veillez à bien remplir correctement tous les champs requis (ceux avec *).", lang, "formAlert")}
                    </Alert>
                }

                <Button
                    disabled={!isFormValid()}
                    className="bouton-submit-formulaire"
                    variant="contained"
                    onClick={_ => handleFormSubmit()}>
                    {translator("Suivant", lang, "formNext")}
                </Button>
            </div>

        </div>

    )
}




export default FormulaireInfosClient